// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget.sample-list {
  overflow-y: hidden;
  flex: 1;
}

.samples .controls {
  flex-grow: 0;
  background: #444;
  border-radius: 3px;
}

.samples .controls .sample-list-buttons {
  flex-direction: row;
  justify-content: space-around;
}

.samples .samples-list {
  overflow-y: hidden;
  flex-grow: 1;
}

.samples {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  color: white;
  font-family: monospace;
  margin-right: 0;
}

.samples .samples-row {
  display: flex;
  border-left: 2px solid rgba(0, 0, 0, 0);
  padding: 2px;
  flex-shrink: 0;
  overflow-x: hidden;
}

.samples .samples-row.current-sample {
  border: 2px solid #444;
  border-radius: 3px;
}

.samples .samples-index {
  display: table-cell;
  text-align: center;
  min-width: 24px;
}

.samples .samples-index div {
  padding: 0 3px;
  border: 1px solid gray;
  border-radius: 2px;
}

.samples .samples-name div {
  padding-left: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 0 auto;
}

.samples .samples-row.current-sample .samples-index div {
  background: #090;
}

.samples .samples-name {
  display: flex;
  flex-direction: row;
  flex: 1 0 auto;
  text-align: left;
  overflow: hidden;
}

.samples .samples-top-padding,
.sampless .samples-bottom-padding {
  flex-shrink: 0;
}

.samples input.inline-editor {
  font-size: 1em;
  font-family: monospace;
  padding-top: 0;
  padding-left: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/sample_list/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".widget.sample-list {\n  overflow-y: hidden;\n  flex: 1;\n}\n\n.samples .controls {\n  flex-grow: 0;\n  background: #444;\n  border-radius: 3px;\n}\n\n.samples .controls .sample-list-buttons {\n  flex-direction: row;\n  justify-content: space-around;\n}\n\n.samples .samples-list {\n  overflow-y: hidden;\n  flex-grow: 1;\n}\n\n.samples {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  color: white;\n  font-family: monospace;\n  margin-right: 0;\n}\n\n.samples .samples-row {\n  display: flex;\n  border-left: 2px solid rgba(0, 0, 0, 0);\n  padding: 2px;\n  flex-shrink: 0;\n  overflow-x: hidden;\n}\n\n.samples .samples-row.current-sample {\n  border: 2px solid #444;\n  border-radius: 3px;\n}\n\n.samples .samples-index {\n  display: table-cell;\n  text-align: center;\n  min-width: 24px;\n}\n\n.samples .samples-index div {\n  padding: 0 3px;\n  border: 1px solid gray;\n  border-radius: 2px;\n}\n\n.samples .samples-name div {\n  padding-left: 3px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1 0 auto;\n}\n\n.samples .samples-row.current-sample .samples-index div {\n  background: #090;\n}\n\n.samples .samples-name {\n  display: flex;\n  flex-direction: row;\n  flex: 1 0 auto;\n  text-align: left;\n  overflow: hidden;\n}\n\n.samples .samples-top-padding,\n.sampless .samples-bottom-padding {\n  flex-shrink: 0;\n}\n\n.samples input.inline-editor {\n  font-size: 1em;\n  font-family: monospace;\n  padding-top: 0;\n  padding-left: 3px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
